import Dragger from './Dragger'
import Upload from './Upload'

import './style/css'

Upload.Dragger = Dragger
export { Dragger }
export default Upload
